import { collection, addDoc } from "firebase/firestore"
import { db } from "./firebase.service";

export interface ContactFormData {
  name: string
  email: string
  message: string
  createdAt: Date
  phone: string;
}

export const createContactMessage = async (data: Omit<ContactFormData, "createdAt">) => {
  const contactRef = collection(db, "contacts")
  const docRef = await addDoc(contactRef, {
    ...data,
    createdAt: new Date()
  })
  return docRef.id
}
